// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.better-options-card {
  margin-top: 20px;
}

.better-options-card h3 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 1.05rem;
  color: #1c4f8a;
}

.better-options-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.affiliate-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 16px;
  background: #f5f8ff;
  border: 1px solid #dce8ff;
  border-radius: 8px;
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.15s, border-color 0.15s;
}

.affiliate-card:hover {
  border-color: #1c4f8a;
  box-shadow: 0 2px 8px rgba(28, 79, 138, 0.12);
}

.affiliate-icon {
  font-size: 1.6rem;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 2px;
}

.affiliate-content {
  flex: 1 1;
}

.affiliate-content strong {
  display: block;
  font-size: 0.95rem;
  color: #1c4f8a;
  margin-bottom: 4px;
}

.affiliate-content p {
  font-size: 0.85rem;
  color: #445;
  margin: 0 0 6px 0;
  line-height: 1.5;
}

.affiliate-cta {
  font-size: 0.82rem;
  font-weight: 600;
  color: #1c4f8a;
}

.affiliate-disclosure {
  font-size: 0.75rem;
  color: #888;
  margin-top: 12px;
  margin-bottom: 0;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/BetterOptions.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".better-options-card {\n  margin-top: 20px;\n}\n\n.better-options-card h3 {\n  margin-top: 0;\n  margin-bottom: 16px;\n  font-size: 1.05rem;\n  color: #1c4f8a;\n}\n\n.better-options-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.affiliate-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 14px 16px;\n  background: #f5f8ff;\n  border: 1px solid #dce8ff;\n  border-radius: 8px;\n  text-decoration: none;\n  color: inherit;\n  transition: box-shadow 0.15s, border-color 0.15s;\n}\n\n.affiliate-card:hover {\n  border-color: #1c4f8a;\n  box-shadow: 0 2px 8px rgba(28, 79, 138, 0.12);\n}\n\n.affiliate-icon {\n  font-size: 1.6rem;\n  line-height: 1;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.affiliate-content {\n  flex: 1;\n}\n\n.affiliate-content strong {\n  display: block;\n  font-size: 0.95rem;\n  color: #1c4f8a;\n  margin-bottom: 4px;\n}\n\n.affiliate-content p {\n  font-size: 0.85rem;\n  color: #445;\n  margin: 0 0 6px 0;\n  line-height: 1.5;\n}\n\n.affiliate-cta {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #1c4f8a;\n}\n\n.affiliate-disclosure {\n  font-size: 0.75rem;\n  color: #888;\n  margin-top: 12px;\n  margin-bottom: 0;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
